enum WaybillNoTypeCode {
    XIAOHONGSHU_V2 = "XIAOHONGSHU_V2",
}

export default WaybillNoTypeCode;
